import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import { BackTop } from 'antd'
import LoginChecker from 'containers/shared/LoginChecker'
import AppHeader from 'containers/shared/AppHeader'
import AppFooter from 'containers/shared/AppFooter'
import HeaderMenu from 'containers/shared/HeaderMenu'
import UserOperator from 'containers/shared/UserOperator'
import SearchBar from 'containers/shared/SearchBar'
import menuData from '../config/menu'
import * as styles from './style.scss'
import AppLogo from '../assets/images/logo.png'

interface IBasicLayoutProps extends RouteComponentProps<any> {
  loginStore: ILoginStore.LoginStore
  searchStore: ISearchStore.SearchStore
  globalStore: any
}

@inject('loginStore', 'searchStore', 'globalStore')
@observer
class BasicLayout extends React.Component<IBasicLayoutProps, any> {
  componentDidMount() {
    const {
      globalStore: { fetchUserInfo, getStaffInfo },
    } = this.props
    fetchUserInfo()
    getStaffInfo()
  }

  handleSearch = value => {
    const { history, searchStore } = this.props
    searchStore.setSearchKeyWords(value.length ? value : '汪总')
    searchStore.querySearchResult(1, 10)
    history.push(`/searchresult?q=${value}`)
  }

  render() {
    const {
      location,
      children,
      loginStore,
      match: { path },
    } = this.props

    return (
      <LoginChecker isLogin={loginStore.isLogin}>
        <HmtFrame>
          <AppHeader>
            <HeaderMenu
              appBaseUrl="/"
              appLogo={AppLogo}
              menuData={menuData}
              pathname={location.pathname}
            />
            <UserOperator />
          </AppHeader>
          {path !== '/glory' && <SearchBar onSearch={this.handleSearch} />}
          <div>{children}</div>
          {path !== '/glory' && <AppFooter />}
          <BackTop className={styles.navibar} />
        </HmtFrame>
      </LoginChecker>
    )
  }
}

function HmtFrame({ children }) {
  if ((window as any)._hmt) {
    ;(window as any)._hmt.push(['_trackPageview', `/${window.location.hash}`])
  }
  return children
}

export default withRouter(BasicLayout)
